import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { WeatherStation, UpdateWeatherStationDto } from 'types';

export const updateWeatherStation = ({
  data,
  stationId,
}: {
  data: UpdateWeatherStationDto;
  stationId: number;
}): Promise<WeatherStation> => {
  return axios.put(`/api/weather/stations/${stationId}`, data);
};

type UseUpdateWeatherStationOptions = {
  config?: MutationConfig<typeof updateWeatherStation>;
};

export const useUpdateWeatherStation = ({
  config,
}: UseUpdateWeatherStationOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousWeatherStations) {
        queryClient.setQueryData(
          ['weatherStations'],
          context.previousWeatherStations
        );
      }
    },
    onSuccess: () => {
      queryClient.refetchQueries(['weatherStations']);
    },
    ...config,
    mutationFn: updateWeatherStation,
  });
};
